/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSpawnNode: {
  name: 'spawn_node';
  data: string;
} = {
  name: 'spawn_node',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M472.99 300.43c0-1.195 1.195-2.391 2.391-2.391h23.906c1.195 0 2.391 1.195 2.391 2.391v2.391H472.99v-2.391zM477.771 286.086h19.125v9.563h-19.125v-9.563zM477.771 269.352h19.125v4.781h-19.125v-4.781zM477.771 276.523h19.125v7.172h-19.125v-7.172zM477.771 264.57h19.125v2.391h-19.125v-2.391z" transform="translate(-7003.996 -3949.43) scale(14.99999)"/></svg>`,
};
